import axios from 'axios';
import { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './Login.css';
import NavBarShan from '../NavBar/NavBar';
import LoadingLoggedIn from '../Loading/Loading';

class LoginDet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeClassName: 'far fa-times-circle',
      CredentialChkUrl: 'https://my-webpage-node.vercel.app/Login/',
      CredentialData: [],
      Loading: false,
      line1: 'Login',
      textAnimationLine1: [],
      editPopUp: false,
      editPopUpData: {}
    }
  }

  async componentDidMount() {
    let tempArr1 = []
    this.props.SelectedPage('LoggedInPage', {
      SelectedPage: 5
    })
    if (this.state.textAnimationLine1.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
      }
    }
    this.setState({
      textAnimationLine1: tempArr1,
      editPopUpData: {}
    })
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40 && this.state.Loading) {
        let arr1 = this.state.textAnimationLine1;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
          })
        }
      }
    }, 100);
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    try {
      let reqBody = {
        authCode: "626548a4aa11b1c662c5539c",
        method: 'get'
      }
      let Data = await axios.post(this.state.CredentialChkUrl, reqBody);
      this.setState({
        LoginPageData: Data.data,
        Loading: true
      })
    } catch (err) {
      console.log(err)
      this.setState({
        Loading: false
      })
    }
  }

  render() {
    if (this.props.localStorageData.NavBarLoginText.Login === false) {
      this.props.history.push('/Login');
    }
    return (<>
      <div className='LoggedInCommonDiv'>
        <NavBarShan />
        {this.state.Loading ?
          <div className='LoggedInSideDiv'>
            <div className='LoginHeadingDiv'>
              {this.state.line1.split('').map((ite, index) => {
                return (<>{ite === ' ' ? <span className='LoginAniLetterSpace'>{ite}</span> : <span onMouseEnter={() => {
                  let ani = this.state.textAnimationLine1
                  ani[index] = { letterAni: 1 }
                  this.setState({
                    textAnimationLine1: ani
                  })
                }} onMouseLeave={() => {
                  setTimeout(() => {
                    let ani = this.state.textAnimationLine1
                    ani[index] = { letterAni: 2 }
                    this.setState({
                      textAnimationLine1: ani
                    })
                  }, 500)
                }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'LoginAniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'LoginAniLetterMouse LoginAniLetter' : 'LoginAniLetter'}>{ite}</span>}
                </>)
              })}
            </div>
            <table className='LoginLoggedInTbl'>
              <thead>
                <tr>
                  <th className='Loginpd20 LoginLoggedInTblBrd'>ID No</th>
                  <th className='Loginpd20 LoginLoggedInTblBrd'>Role Description</th>
                  <th className='Loginpd20 LoginLoggedInTblBrd'>Option</th>
                </tr>
              </thead>
              <tbody>
                {/* {this.state.LoginData.map((ite, index) => {
                                    return (<>
                                        <tr>
                                            <td className='Loginpd20 LoginLoggedInTblBrd'>{ite?._id}</td>
                                            <td className='Loginpd20 LoginLoggedInTblBrd'>{ite?.role}</td>
                                            <td className='Loginpd20 LoginEditBtn LoginLoggedInTblBrd' onClick={() => {
                                                this.setState({
                                                    editPopUpData: ite,
                                                    editPopUp: true
                                                })
                                            }}>Edit</td>
                                        </tr>
                                    </>)
                                })} */}
              </tbody>
            </table>
          </div> :
          <LoadingLoggedIn />}
        {this.state.editPopUp ?
          <div className='LoginEditDataPopUpLoggedIn'>
          </div>
          : ''}
      </div>

    </>);
  }
}

const mapStateToProps = (state) => ({
  localStorageData: state.Reducer
})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  }),
  LoadingPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginDet));